import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Ademas } from '../models/ademas';

const dataservice = 'assets/data/mock-more-data.json';

@Injectable({
  providedIn: 'root'
})
export class MoreService {

  more: Ademas = new Ademas();

  constructor(private http: HttpClient) { }

  getMore(): Observable<HttpResponse<Ademas[]>> {
    return this.http.get<Ademas[]>(
      dataservice, {observe: 'response'}
    );
}}
